module.exports = __webpack_public_path__ + "assets/media/day32.f24b6aee.mp3";